import React, { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router';
import { Link, Redirect, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import './BillingComp.css';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

const translations = {
  en: require('../langs/en.json'),
  jp: require('../langs/jp.json')
};

const srcMap = {
  history: 'https://app.tender.io/Scripts/widgets/history.js',
  profile: 'https://app.tender.io/Scripts/widgets/profile.js',
  jquery: 'https://ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js'
};

const injectSync = (instance, src) => {
  return new Promise((resolve) => {
    if (window.jQuery) return resolve();
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.onload = resolve;
    instance.appendChild(s);
    return s;
  });
};

const injectTender = (instance, src) =>
  new Promise((resolve) => {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.onload = resolve;
    instance.appendChild(s);
  });

const initHistory = (d) => {
  var history = new window.InvoiceHistory.Widget.History();
  history.identify_customer({ id: d.publishable, email: d.stripeCustomerId });
  history.auth_customer({
    date: d.date,
    auth_token: d.hashMd5
  });
};

const initProfile = (d) => {
  var profile = new window.InvoiceHistory.Widget.Profile();
  profile.identify_customer({ id: d.publishable, email: d.stripeCustomerId });
  profile.auth_customer({
    date: d.date,
    auth_token: d.hashMd5
  });
};

const fetchSecrets = () =>
  fetch('/api/tenderio', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  });

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  language: getActiveLanguage(state.locale).code
});

class History extends Component {
  componentDidMount() {
    const historyP = injectSync(document.body, srcMap.jquery).then(() =>
      injectTender(this.instanceHistory, srcMap.history)
    );
    historyP
      .then(fetchSecrets)
      .then((data) => data.json())
      .then(initHistory)
      .catch(console.error);
  }
  render() {
    const { translate } = this.props;
    return (
      <div>
        <h3>{translate('billing.invoices_header')}</h3>
        <div data-ih-history="true" />
        <div ref={(el) => (this.instanceHistory = el)} />
      </div>
    );
  }
}

const HistoryComp = connect(mapStateToProps, null)(History);

class Profile extends Component {
  componentDidMount() {
    const profileP = injectSync(document.body, srcMap.jquery).then(() =>
      injectTender(this.instanceProfile, srcMap.profile)
    );
    profileP
      .then(fetchSecrets)
      .then((data) => data.json())
      .then(initProfile)
      .catch(console.error);
  }
  render() {
    const { match, language, translate } = this.props;
    return (
      <div>
        <h3>{translate('billing.profile_header')}</h3>
        <div data-ih-profile="true" />
        <div ref={(el) => (this.instanceProfile = el)} />
      </div>
    );
  }
}
const ProfileComp = connect(mapStateToProps, null)(Profile);

class Details extends Component {
  state = {
    stripeCustomerId: undefined,
    loading: true
  };
  componentDidMount() {
    fetchSecrets()
      .then((data) => data.json())
      .then((d) =>
        this.setState({
          stripeCustomerId: d.stripeCustomerId,
          loading: false,
          publishable: d.publishable
        })
      )
      .catch(console.error);
  }
  render() {
    const { match, language, translate } = this.props;
    const { stripeCustomerId, loading, publishable } = this.state;
    const formUrl = `https://app.tender.io/public/account/${publishable}/customer/${stripeCustomerId}`;
    return (
      <div>
        <h3>{translate('billing.payment_detail_header')}</h3>
        {loading && <span>Loading ...</span>}
        {!loading && (
          <div>
            {stripeCustomerId ? (
              <iframe
                id="form"
                src={formUrl}
                style={{ width: '100%', height: '1000px', border: 'none' }}
              />
            ) : (
              <div>You are not subscribed to any plan</div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const DetailsComp = connect(mapStateToProps, null)(Details);

class BillingComp extends Component {
  render() {
    const { match, language, translate } = this.props;
    const tender = translations[language].billing.tender;
    const transStyles = Object.keys(tender).map(
      (key) =>
        `${key} {visibility: hidden; position: relative;} \n${key}:after { visibility: visible; position: absolute; top: 0; left: 0; right: 0; bottom: 0; content: '${
          tender[key]
        }' }`
    );

    return (
      <div className="profile">
        <style dangerouslySetInnerHTML={{ __html: transStyles.join('\n') }} />
        <h1 className="profile-header">{translate('billing.billing')}</h1>

        <div className="content">
          <div className="billing-tabs">
            <NavLink
              to={`${match.url}/history`}
              className="billing-tab-item"
              activeClassName="selected"
            >
              {translate('billing.history')}
            </NavLink>
            <NavLink
              to={`${match.url}/profile`}
              className="billing-tab-item"
              activeClassName="selected"
            >
              {translate('billing.profile')}
            </NavLink>
            <NavLink
              to={`${match.url}/details`}
              className="billing-tab-item"
              activeClassName="selected"
            >
              {translate('billing.payment_details')}
            </NavLink>
          </div>
          <Switch>
            <Route path={`${match.url}/history`} component={HistoryComp} />
            <Route path={`${match.url}/profile`} component={ProfileComp} />
            <Route path={`${match.url}/details`} component={DetailsComp} />
            <Redirect exact from={match.url} to={`${match.url}/history`} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(BillingComp);



// WEBPACK FOOTER //
// ./src/billing/BillingComp.js